import { jsxs, jsx } from "react/jsx-runtime";
const IllustrationSuccessSvg = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: 64,
    height: 64,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M51.874 28.145c.08.564.08 1.209.08 1.773 0 12.646-10.31 23.037-23.036 23.037-12.727 0-22.957-10.31-22.957-23.037C5.96 17.27 16.27 6.88 28.998 6.88a22.752 22.752 0 0 1 13.935 4.753l3.786-3.706C41.886 3.98 35.684 1.644 29 1.644 13.371 1.725.724 14.371.724 29.917c0 15.627 12.646 28.273 28.193 28.273 15.546 0 28.273-12.646 28.273-28.272 0-2.175-.242-4.27-.725-6.203l-4.592 4.43Z",
          fill: "#88C8C4"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "m26.904 38.858-9.183-9.585c-.967-1.047-.967-2.739.08-3.705 1.048-.967 2.74-.967 3.706.08l6.927 7.25a1.168 1.168 0 0 0 1.692 0L55.58 8.33a2.652 2.652 0 0 1 3.705.08 2.652 2.652 0 0 1-.08 3.706l-27.79 26.823c-1.29 1.289-3.303 1.208-4.511-.08Z",
          fill: "#009F80"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "m56.949 23.232-1.047 1.047c.402 1.853.644 3.786.644 5.639 0 15.143-12.324 27.548-27.548 27.548-15.224 0-27.548-12.325-27.548-27.549C1.45 14.774 13.774 2.37 28.998 2.37c6.202 0 12.324 2.175 17.157 6.042l1.047-.967A28.877 28.877 0 0 0 28.998 1C12.968 1 0 13.969 0 29.918c0 15.948 12.969 28.917 28.918 28.917 15.948 0 28.917-12.969 28.917-28.918 0-2.255-.242-4.51-.806-6.766l-.08.08Z",
          fill: "#009F80"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "m26.904 38.858-9.183-9.585c-.967-1.047-.967-2.739.08-3.705 1.048-.967 2.74-.967 3.706.08l6.927 7.25a1.168 1.168 0 0 0 1.692 0L55.58 8.33a2.652 2.652 0 0 1 3.705.08 2.652 2.652 0 0 1-.08 3.706l-27.79 26.823c-1.29 1.289-3.303 1.208-4.511-.08Z",
          fill: "#009F80"
        }
      )
    ]
  }
);
export {
  IllustrationSuccessSvg
};
